function CardsAbout() {
    return ( 
        <>
            <section className="cards-about">
                <div className="container">
                    <h2 className="heading">What we do?</h2>
                    <p class="text-about">
                        <b className="color">We're not just any onlyfans agency;</b> we're revolutionizing the way OnlyFans creators scale their accounts. Our Mission is to empower creators and be the best in the industry.
                    </p>

                    <ul className="cards">
                        <li className="card-item">
                            <div className="icon">
                                🌟
                            </div>
                            <div className="card-heading">
                                Full management
                            </div>
                            <div className="description">
                                While creating room for your creativity, we take care of everything else for you. We make sure, that your content delivers the highest possible impact and revenue.
                            </div>
                        </li>

                        <li className="card-item">
                            <div className="icon">
                                🔥
                            </div>
                            <div className="card-heading">
                                Fan Interaction
                            </div>
                            <div className="description">
                            We will help you dominate OnlyFans by rapidly scaling your account and skyrocketing your sales!
                            </div>
                        </li>

                        <li className="card-item">
                            <div className="icon">
                                💸
                            </div>
                            <div className="card-heading">
                                Account Growth
                            </div>
                            <div className="description">
                                We help you to build and sustain a highly profitable Fan base by identifying the right tools & channels for you and continuously adapting the strategies to keep scaling your account.
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
        </>
     );
}

export default CardsAbout;